import * as React from 'react';
import { PermissionsCtx } from '../components/permissions-context/permissions-ctx';
export const withPermissions = (component) => {
    return (props) => {
        return (React.createElement(PermissionsCtx.Consumer, null, (permissions) => React.createElement(component, { ...props, permissions })));
    };
};
//# sourceMappingURL=with-permissions.js.map